module.exports = __webpack_public_path__ + "img/鼓掌.62b9b72d.png";